import React, { Fragment } from "react";
import { Button, Row, Col, Alert } from "react-bootstrap";

const CourseForm = ({ info }) => {
  return (
    <Fragment>
      <Alert variant="info">
        {info.courseNumber} - {info.courseName}
      </Alert>
    </Fragment>
  );
};

const WeekForm = ({
  weekId,
  week,
  state,
  auth,
  handelAuth,
  handelEdit,
  handelAssessment,
}) => {
  return (
    <Fragment>
      <Row className="p-2 align-items-center">
        <Col>{(week-11) ?? undefined} 주차</Col>
        <Col>상태 : {state}</Col>
        <Col className="col-6">
          <Button onClick={() => handelAuth(auth)} className="me-2">
            인증코드
          </Button>
          <Button onClick={handelEdit} value={weekId} className="me-2">
            수정하기
          </Button>
          <Button onClick={handelAssessment} value={weekId} className="me-2">
            수행평가
          </Button>
        </Col>
      </Row>
    </Fragment>
  );
};

export const ProfessorDetailForm = ({
  professor,
  handelAuth,
  handelEdit,
  handelAssessment,
}) => {
  return (
    <Fragment>
      {professor.courses.map((it, index) => {
        return (
          <Fragment key={index}>
            <hr />
            <CourseForm info={it.info} />
            {it.weeks.map((st, sIndex) => {
              return (
                <div key={sIndex}>
                  <WeekForm
                    weekId={st._id}
                    week={st.week}
                    state={st.state}
                    auth={st.auth}
                    handelAuth={handelAuth}
                    handelEdit={handelEdit}
                    handelAssessment={handelAssessment}
                  />
                </div>
              );
            })}
          </Fragment>
        );
      })}
      <hr />
    </Fragment>
  );
};
